import React from 'react';
import { Link } from 'react-router-dom';
import { getAnalyticsCourses } from '../../services/teacherApi';
import { AnalyticsGate, LoadState, Pager, Panel, Records, RestoreFocus, useAnalytics, useQueryState } from './AnalyticsShared';

function Groups() {
  const {pageNumber, update} = useQueryState();
  const page = pageNumber();
  const resource = useAnalytics(`course-groups/${page}`, signal => getAnalyticsCourses({page, limit: 20}, signal));
  return <Panel><h2 data-results-heading tabIndex={-1}>按课程查看学生</h2>
    <LoadState resource={resource} label="正在加载课程…">{data => <>
      <RestoreFocus ready />
      {!data.items.length && <p>{page > 1 ? '当前页暂无记录。' : '暂无课程，请先创建课程。'} <Link to="/teacher/courses/new">创建课程</Link></p>}
      <Records>{data.items.map(c => <article key={c.courseId}><h3>{c.title || '未命名课程'}</h3>
        <p>在籍学生 {c.enrolledStudents} 人 · 知识元 {c.assignedTopics} 个 · {c.isPublished ? '已发布' : '未发布'}</p>
        <nav aria-label={`${c.title || '未命名课程'}操作`}>
          <Link to={`/teacher/courses/${c.courseId}/students?page=1`} state={{courseListPage: page}}>查看学生</Link>
          <Link to={`/teacher/courses/${c.courseId}/analytics?tab=overview`} state={{courseListPage: page}}>课程概览</Link>
          <Link to={`/teacher/courses/${c.courseId}`}>编辑课程</Link>
        </nav>
      </article>)}</Records>
      <Pager pagination={data.pagination} onPage={p => update({page: p, view: 'students'})} />
    </>}</LoadState>
  </Panel>;
}
export const CourseGroups = () => <div style={{gridColumn: '1 / -1'}}><AnalyticsGate><Groups /></AnalyticsGate></div>;
